export default __webpack_public_path__ + "static/media/inventory-inactive.b8eb64a4.svg";